import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// USER INBOX NOTIFICATIONS API
// ==============================================

// Get User Inbox Notifications
export const getUserInboxNotifications = async (params) => {
    try {
        const { userId, roleId } = params;
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetUserInboxNotifications?userId=${userId}&roleId=${roleId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};